export default "__VITE_ASSET__CBh$TxOG__"